import { Category } from '@/domain/models/content/category'
import { EnrollmentCategory } from '@/domain/models/content/enrollment-category'
import { ValidAccountState } from '@/presentation/contexts/auth/account-provider'
import useAccount from '@/presentation/hooks/auth/use-account'
import { LDClient, useLDClient } from 'launchdarkly-react-client-sdk'
import { useQueryClient } from 'react-query'
import { RouteObject } from 'react-router-dom'
import { makeCategoryGroupSearchPage, makeCategorySearchPage } from '@/main/factories/pages'
import CategorySearchLoader from '../loaders/search/category-search-loader'
import PathConstants from '../path-contants'

const BuildCategoryRoutes = (): RouteObject[] => {
  const [account] = useAccount() as ValidAccountState
  const queryClient = useQueryClient()
  const ldClient = useLDClient() as LDClient
  return [
    ...Category.getAvailables().map(category => {
      return {
        path: PathConstants.getCategoryRoutePath(category),
        id: category.name.toLocaleLowerCase(),
        element: makeCategorySearchPage(category),
        loader: new CategorySearchLoader(account, queryClient, ldClient, [category]).loader
      }
    }),
    ...EnrollmentCategory.getGroups().map(group => {
      return {
        path: PathConstants.getCategoryGroupRoutePath(group),
        id: group.name.toLocaleLowerCase(),
        element: makeCategoryGroupSearchPage(group),
        loader: new CategorySearchLoader(account, queryClient, ldClient, group.categories).loader
      }
    })
  ]
}

export default BuildCategoryRoutes
